import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../../providers/Layout.provider';
import { useBank } from '../../../../providers/Bank.provider';
import styles from './BankTypeContainer.module.scss';

const { Box, Button } = vp;

type ConnectionTypeProps = {
  hasNoOnlineOption: boolean;
};

type FC = FunctionComponent<ConnectionTypeProps>;

const ConnectionType: FC = (props: ConnectionTypeProps) => {
  const { hasNoOnlineOption } = props;
  const { color } = useLayout();
  const { t } = useTranslation('translations', { keyPrefix: 'BankConnection' });
  const { FinancialInstitution, BankingType, setBankingType } = useBank();

  return (
    <Box flx="col">
      <h3 className={styles.connectionType}>{`${t('connectionType')}`}</h3>

      <div className={styles.typeButtonContainer}>
        <Button
          id="online-banking"
          label={`${t('onlineButton')}`}
          type="submit"
          color={vp.getLuminance(color) > 0.5 ? 'primary' : 'none-light'}
          background={BankingType === 'online' ? color : 'none'}
          textColor={BankingType === 'online' ? vp.getContrastColor(color) : '#747474'}
          width="100%"
          height="46px"
          round
          bold
          noShadow
          fontUnit="px"
          textSize={15}
          fontWeight={BankingType === 'online' ? 700 : 400}
          icon="check"
          iconLocation="left"
          isIconVisible={BankingType === 'online'}
          isDisabled={FinancialInstitution?.FinancialInstitutionID === '' && !hasNoOnlineOption}
          onClick={() => {
            setBankingType('online');
          }}
        />
        <Button
          id="manual-banking"
          label={`${t('manualButton')}`}
          type="submit"
          color={vp.getLuminance(color) > 0.5 ? 'primary' : 'none-light'}
          background={BankingType === 'manual' ? color : 'none'}
          textColor={BankingType === 'manual' ? vp.getContrastColor(color) : '#747474'}
          width="100%"
          height="46px"
          round
          bold
          noShadow
          fontUnit="px"
          textSize={15}
          fontWeight={BankingType === 'manual' ? 700 : 400}
          icon="check"
          iconLocation="left"
          isIconVisible={BankingType === 'manual'}
          isDisabled={FinancialInstitution?.FinancialInstitutionID === '' && !hasNoOnlineOption}
          onClick={() => {
            setBankingType('manual');
          }}
        />
      </div>
    </Box>
  );
};

export default ConnectionType;
